import { AvailabilityModelBase } from './AvailabilityModel.base'

/* A graphql query fragment builders for AvailabilityModel */
export {
  selectFromAvailability,
  availabilityModelPrimitives,
  AvailabilityModelSelector,
} from './AvailabilityModel.base'

/**
 * AvailabilityModel
 */
export const AvailabilityModel = AvailabilityModelBase.views((self) => ({
  get store() {
    return self.__getStore()
  },
  get booking() {
    return self.store.booking
  },
  get internalUid() {
    return self?.siteType?.internalUid
  },
  get currentBookingOptions() {
    return self.bookingOptions.filter((bo) => bo.description !== 'BYS') || []
  },
})).actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  },
}))
